import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["readOnly", "value", "name", "label", "onChange", "form"];
import React, { useState, useEffect } from "react";
import { Field } from "@xo-union/tk-component-fields";
import { useDebouncedCallback } from "use-debounce";
import moment from "moment";
var DEBOUNCE_TIMEOUT = 100;
var DateDropDownField = function DateDropDownField(_ref) {
  var readOnly = _ref.readOnly,
    value = _ref.value,
    name = _ref.name,
    label = _ref.label,
    onChange = _ref.onChange,
    errors = _ref.form.errors,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    dateValue = _useState2[0],
    setDateValue = _useState2[1];
  var _useDebouncedCallback = useDebouncedCallback(function (momentDate) {
      onChange(momentDate);
    }, DEBOUNCE_TIMEOUT),
    _useDebouncedCallback2 = _slicedToArray(_useDebouncedCallback, 1),
    debouncedOnChange = _useDebouncedCallback2[0];
  var errorMessage = errors[name];
  var isValidDate = !errorMessage && (!dateValue || moment.utc(dateValue, ['MM/DD/YYYY', 'MMMM DD, YYYY'], true).isValid());
  useEffect(function () {
    if (value) {
      setDateValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(Field, _extends({
    readOnly: readOnly,
    name: name,
    label: label,
    value: dateValue,
    onChange: function onChange(evt) {
      setDateValue(evt.currentTarget.value);
      var momentDate = moment.utc(evt.currentTarget.value, ['MM/DD/YYYY', 'MMMM DD, YYYY'], true);
      if (momentDate.isValid()) {
        debouncedOnChange(momentDate);
      } else {
        debouncedOnChange(evt.currentTarget.value);
      }
    },
    state: isValidDate ? 'neutral' : 'invalid',
    subText: !isValidDate && !readOnly ? errorMessage || 'Please enter a valid date in the correct format (MM/DD/YYYY)' : '',
    placeholder: readOnly ? ' ' : 'MM/DD/YYYY'
  }, props, {
    "data-testid": "date-picker-dropdown"
  }));
};
export default DateDropDownField;